import isNil from './is-nil';
export default (function (value) {
    if (isNil(value))
        return '';
    return value.toString();
});
//# sourceMappingURL=to-string.js.map